import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { RealtySource } from 'shared/api/kyrgyzstan/search/model'
import { CurrencySom } from 'shared/constants'
import GhostImage from 'shared/images/ghost.png'
import { priceShow } from 'shared/lib/priceShow'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { Button } from 'shared/ui/button'
import { ImageOptimized } from 'shared/ui/image-optimized'

import { RealtySelectionItem } from '../../types'

import s from './styles.module.scss'

interface RealtyOptionCardProps {
  item: RealtySelectionItem
  isSelected?: boolean
  onSelect?: () => void
}

export const RealtyOptionCard = ({
  item,
  isSelected = false,
  onSelect,
}: RealtyOptionCardProps) => {
  const { t } = useTranslation()

  const hasValidTotalPrice =
    item.total_price != null &&
    item.total_price !== '' &&
    parseFloat(item.total_price) > 0

  return (
    <div
      className={s.card}
      onClick={onSelect}
    >
      <div className={s.imageWrapper}>
        <ImageOptimized
          src={item.images[0]?.image_url}
          errorImage={GhostImage}
          alt={item.images[0]?.id}
          className={s.image}
        />
      </div>

      <div className={s.content}>
        <p className={clsx('extra-bold-16', s.price)}>
          <span className={s.priceValue}>
            {priceShow(
              String(
                hasValidTotalPrice ? item.total_price : (item.price ?? '0'),
              ),
            )}{' '}
            {CurrencySom}
          </span>{' '}
          <span className={s.priceLabel}>
            {hasValidTotalPrice
              ? t('kyrgyzstan_block.card.for_nights', {
                  count: item.nights ?? 0,
                  nights: t('kyrgyzstan_block.card.nights', {
                    count: item.nights ?? 0,
                  }),
                })
              : t('kyrgyzstan_block.detail.per_night')}
          </span>
        </p>
        <div className={s.divider} />
        <div className={s.info}>
          <h3 className={clsx('semi-bold-14', s.name)}>{item.title}</h3>

          {item?.source === RealtySource.EXELY &&
            item?.dynamic_fields?.items?.map((field) => (
              <div
                key={field.id}
                className={clsx('semi-bold-12', s.dynamicFieldWrapper)}
              >
                <AppIcon
                  width={12}
                  height={12}
                  id={AllIcons.MEAL_TOUR}
                  className={s.dynamicFieldIcon}
                />
                <span>{field.name}:</span>

                <span>{field.fields?.[0]?.name}</span>
              </div>
            ))}
        </div>

        {onSelect && !isSelected && (
          <Button
            variant="yellow"
            className={clsx('semi-bold-15', s.button)}
          >
            {t('kyrgyzstan_block.detail.choose_option')}
          </Button>
        )}
      </div>
    </div>
  )
}
